module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/volume-down-3c0eac27d5c9796963b749e98c420c46.svg";